/**
 * The platform's name, in one place (D-123, D-369).
 *
 * **STGD is the platform, not what a fan sees.** BRE ran this as "BTownTix",
 * a customer-facing brand. STGD runs it for teams, and what a customer sees is
 * "<Team> Ticketing", built from the organization in Admin → Branding
 * (`ticketingName` in the API). This constant names the software itself: the
 * admin and box-office chrome, a PDF's producer and creator, an iCal PRODID,
 * the printer test page.
 *
 * What this file holds is the name as a **constant**: the places where the
 * software identifies itself and no configuration should change the answer — a
 * PDF's `Creator`, an iCal `PRODID`, the scanner app's description. The
 * customer-facing name is read from configuration instead (`brandName` in the
 * API, `siteBrand` in the storefront), so a deployment that white-labels the
 * storefront can, while the file a customer downloads still honestly records
 * which software wrote it.
 *
 * Before this, "BRE LIVE" was hardcoded in nineteen files and served as both,
 * which is why a Stripe statement and a PDF's metadata said the same string for
 * two unrelated reasons.
 */

export const PLATFORM_NAME = 'STGD';

/** For a `<title>`, an admin header, a login screen: the product, plainly. */
export const PLATFORM_TITLE = PLATFORM_NAME;

/** For a storefront white-labeled under another name, which is not the default. */
export const PLATFORM_ATTRIBUTION = `Ticketing powered by ${PLATFORM_NAME}`;

/**
 * How the product signs a copyright line. The venue running it is named beside
 * this, from branding — two parties own the page and it says so (D-149). It was
 * the site's domain ("BTownTix.com"); STGD's is not the storefront's (D-369).
 */
export const PLATFORM_COPYRIGHT_NAME = PLATFORM_NAME;

/** iCalendar `PRODID`: which software wrote the file (RFC 5545 §3.7.3). */
export const PLATFORM_ICAL_PRODID = `-//${PLATFORM_NAME}//Ticketing//EN`;

/** A PDF's Creator: the program that produced it, not the organization selling. */
export const PLATFORM_PDF_CREATOR = PLATFORM_NAME;
